// Tiny client-side premium helper. Admins always have full access; otherwise a
// user is premium iff `premium_expires_at` is in the future.
export function isPremium(user) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (!user.premium_expires_at) return false;
  const expires = new Date(user.premium_expires_at);
  if (Number.isNaN(expires.getTime())) return false;
  return expires.getTime() > Date.now();
}

export function premiumDaysRemaining(user) {
  if (!isPremium(user)) return 0;
  if (user?.role === "admin") return Infinity;
  const ms = new Date(user.premium_expires_at).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
}
